import { defineAction } from '~/prix'
import residenceImageMockAction from './residenceImageMock.action.json' with { type: 'json' }
import { z } from 'zod'

const residenceImageMockDefinition = defineAction({
  ...residenceImageMockAction,

  input: z.object({
    imagesPerResidence: z.number().optional(),
    seed: z.number().optional(),
  }),
  output: z.object({}),
})

export default residenceImageMockDefinition
